export default __webpack_public_path__ + "static/media/pictogramCards40.ec00b495.svg";